import React from "react";
import { socialMediaLinks } from "./footer.config";
import ExternalLink from "../../../components/external.link/ExternalLink";
import Translation from "../../../localization/Translation";
import styles from "./Footer.module.scss";

const FooterSocialNetworks = () => {
  return (
    <div className={styles["footer__social"]}>
      <h3 className={styles["footer__social-heading"]}>
        <Translation>Follow us on:</Translation>
      </h3>
      <div className={styles["footer__social-networks"]}>
        {Object.keys(socialMediaLinks).map((key) => {
          const social = socialMediaLinks[key];
          const SocialIcon = social.Icon;

          return (
            <ExternalLink
              key={key}
              href={social.url}
              className={styles["footer__social-networks--" + key]}
              title={`BTCX ${social.label}`}
              aria-label={`BTCX ${social.label}`}
            >
              <SocialIcon width={16} height={16} />
            </ExternalLink>
          );
        })}
      </div>
    </div>
  );
};

export default FooterSocialNetworks;
